import { Omni } from "./charts.omni";
import { BulkMail } from "./charts.bulk-mail";


// import {Chart, registerables} from 'chart.js';
// Chart.register(...registerables);
// Alternative Single Line Import
//import Chart from 'chart.js/auto';

class Charts {
    Omni = new Omni();
    BulkMail = new BulkMail();
}
(<any>window).Charts = new Charts();
